export default __webpack_public_path__ + "static/media/frontPageCover.1ca31d3d.png";